function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("image", {
  width: 54,
  height: 54,
  xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAACWUlEQVRoge2aTU7CQBiGX4orExN/dq5wY7tTTyAkblzBEeAEwgmUE0BPIEeQlRsT4ATirnUjK3cqFyCaab6S2q+dCgKdmfAkJmSmhnnydtph5itgxXiwywDE3xmAffqcxBDAFMCL+OzAHyZcszQrEfNg1wFUAdRY52I8AOg78Hu5iXmwRRpNADeUzCoRSboAug786cbEPNh3axKKEwg68O9YTwYLidH8uQdQYp3rZQKgscg8tFhLCpTSIAcp0HcOaAx/IjMxmksdAHXWmQ/iwdLKmntSMZISKZ2zznwZA6jI5FLFFJYKkcrJ5lhHYSnQ2DqslUgUo0mqypySUU97oLBbkR7pA3al2lTir4JfYjSvnnN6pP8H8Z67iM63+K3Y1FAKNOZmtGGeGKX1toFl0roQaZ2EqUUTa2osBRr7PLUgMQPSCpmntiMa9q53a7PPme5Sgv3iYbGGR/QCsWP3qMou0ZeqECt8v16JpL4MEhMcWJI9CZ0pW4qvB5flXIhd6jl2KZeWpiuNLEpGixnJVkw3tmK6YdGvT9OYGC02Ys36M7Jo49E0xhadLJrG0CqcPk3pJNEUHoRT8Av6/eajP/uc/feYVQmKh8U+TN7MCV7QtBfnssv0w03aV+ySsa5MyQG/xAxIzZXt3Xc1XYlMomkhLkbGDfZv6tOIn2yy1T2dM7U1kmonlUmwg78QD/a9BqeaPQd+4h3GEovQUnwdOaYxJpKaGDQvh5AlFj5MKlQ0ogq9LCksUktFp/O3rGOztP9aMGZskdi2rC+OkYWYcYwqnU1DiWJnAD8Nv7r89a2uWwAAAABJRU5ErkJggg=="
});

var SvgSpain = function SvgSpain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spain.b9a90b74.svg";
export { ForwardRef as ReactComponent };